import React, { PureComponent } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { CSVLink } from 'react-csv';

export default class ProgramAggregationTable extends PureComponent {
  render() {
    const { data } = this.props;
    console.log('TABLE data', data);
    if (!data) {
      return <div>No Data</div>;
    }
    return (
      <div>
        <CSVLink data={data} filename={'program_data_'}>
          Download to CSV
        </CSVLink>
        {data && (
          <ReactTable
            data={data}
            pageSize={60}
            pageSizeOptions={[70, 80, 100, 200, 500]}
            //resolveData = {data => this.reshapeData(data)}

            columns={[
              {
                Header: 'Program',
                columns: [
                  {
                    Header: 'Index',
                    id: 'row',
                    maxWidth: 50,
                    filterable: false,
                    Cell: row => {
                      return <div>{row.index + 1}</div>;
                    },
                  },
                  {
                    Header: 'Num',
                    id: 'isNew',
                    maxWidth: 30,
                    accessor: d => (d.isNew ? '=>' : ''),
                  },
                  {
                    Header: 'Chapter Code',
                    id: 'chapterCode',
                    maxWidth: 300,
                    accessor: d => (
                      <a
                        href={
                          '/chapter-analytics/' + d.chapterCode + '/' + d.chapterVersion
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {d.chapterCode}
                      </a>
                    ),
                  },
                  {
                    Header: 'Version',
                    id: 'chapterVersion',
                    maxWidth: 80,
                    accessor: d => d.chapterVersion,
                  },
                  {
                    Header: 'Q1_Score(Bottom 25%) ',
                    id: 'q1Score',
                    maxWidth: 80,
                    accessor: d => (d.q1Score / d.maxScore).toFixed(2),
                  },
                  {
                    Header: 'Accuracy(%) ',
                    id: 'accuracy',
                    maxWidth: 80,
                    accessor: d => (d.medianScore / d.maxScore).toFixed(2),
                  },

                  {
                    Header: 'Q3_Score(Top 25%) ',
                    id: 'q3Score',
                    maxWidth: 80,
                    accessor: d => (d.q3Score / d.maxScore).toFixed(2),
                  },
                  {
                    Header: 'Q1_Time(Top 25%) ',
                    id: 'q1Time',
                    maxWidth: 80,
                    accessor: d => (d.q1Time / 3600.0).toFixed(2),
                  },
                  {
                    Header: 'Time Hr(Median)',
                    id: 'time',
                    maxWidth: 80,
                    accessor: d => (d.medianTime / 3600.0).toFixed(2),
                  },

                  {
                    Header: 'Q3_Time(Bottom 25%) ',
                    id: 'q3Time',
                    maxWidth: 80,
                    accessor: d => (d.q3Time / 3600.0).toFixed(2),
                  },
                  {
                    Header: 'medianScore',
                    id: 'medianScore',
                    maxWidth: 80,
                    accessor: d => d.medianScore,
                  },
                  {
                    Header: 'MaxScore',
                    id: 'maxScore',
                    maxWidth: 80,
                    accessor: d => d.maxScore,
                  },
                ],
              },
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    );
  }
}
